export const GET_SUGGESTED_ITEMS = 'GET_SUGGESTED_ITEMS';
export const RESET_SUGGESTED_ITEMS = 'RESET_SUGGESTED_ITEMS';
export const GET_SUGGESTED_ITEMS_SUCCESS = 'GET_SUGGESTED_ITEMS_SUCCESS';
export const GET_SUGGESTED_ITEMS_ERROR = 'GET_SUGGESTED_ITEMS_ERROR';
